import { useState } from 'react';
import { useGetDocumentInfo } from '@/hooks/useGetDocumentInfo';
import { downloadFileFromFileInfo } from '@/utils';
import { ContentSearchType } from '@common/Providers/GraphqlProvider/generated';
import { showErrorToast } from '@utils/toast/toastHelpers';

export const useDownloadDocument = () => {
  const [downloading, setDownloading] = useState(false);
  const { getDocumentInfo } = useGetDocumentInfo();

  const download = async (
    documentId: string,
    documentType: ContentSearchType | string = ContentSearchType.Document,
    docTitle?: string
  ) => {
    if (!documentId) return;

    try {
      setDownloading(true);

      const _doc = await getDocumentInfo(documentId, documentType as ContentSearchType);

      if (_doc && _doc.file) {
        await downloadFileFromFileInfo(_doc.file, docTitle || _doc.title || 'documento');
      } else {
        showErrorToast('El documento no tiene un archivo asociado para descargar');
      }
    } catch (err) {
      console.error('Error downloading document:', err);
      showErrorToast('Hubo un problema al descargar el documento. Por favor, intenta de nuevo.');
    } finally {
      setDownloading(false);
    }
  };

  return {
    download,
    downloading,
  };
};
